import React, { useContext, Fragment, useState, useEffect } from 'react'

import { Buttons } from '../../lib-atomic'
import { GlobalContext } from '../../lib-atomic-context'
import { LocalStorage, FetchContextApiV2 } from '../../lib-atomic-functions'

import CheckerPopup from '../../app-popup-section-confirm/default'

import CONFIG from '../config'

const CMSENDPOINTS = CONFIG.application.cms.api.endpoints

const CMSAPPROVECONTENTCONFIG = {
  url: CMSENDPOINTS.approvesetup.url,
  method: CMSENDPOINTS.approvesetup.method,
  headers: CMSENDPOINTS.approvesetup.headers,
  responseType: 'json',
}

const Index = (props) => {
  const { token } = LocalStorage.getLS().strapi
  const { user, item, other } = props
  const { isMobView, isPreLoginView, isPromotionView } = other

  const handleAdd = () => {
    props.history.push('/auth/registration')
  }

  const items = [
    {
      user: ['mastercreator', 'creator+approver+publisher'],
      action: handleAdd,
      label: '+ Add User',
      status: true,
    },
  ]

  const checkItems = ({ user }) => {
    return items.filter((item) => item.user.indexOf(user) > -1)
  }

  const menus = checkItems({ user: user[0].user.username })

  return (
    <Fragment>
      {menus.map((menu, index) => {
        return (
          <Fragment>
            <Buttons.Normal key={index} onClick={() => menu.action()}>
              {menu.label}
            </Buttons.Normal>
            &nbsp;
          </Fragment>
        )
      })}
    </Fragment>
  )
}

export default Index
